module.exports = __webpack_public_path__ + "img/pc_banner_terms.71bf3c37.png";